import { EnChapterType } from '@prisma/client'
import { t } from 'src/helpers/translate.helper'
import { BaseEnum } from './BaseEnum'

export class ChapterTypeEnum extends BaseEnum<EnChapterType> {
  static getLabels() {
    return {
      [EnChapterType.AFTERWORD]: t('EnChapterType.AFTERWORD'),
      [EnChapterType.CHAPTER]: t('EnChapterType.CHAPTER'),
      [EnChapterType.EPILOGUE]: t('EnChapterType.EPILOGUE'),
      [EnChapterType.EXTRA]: t('EnChapterType.EXTRA'),
      [EnChapterType.ILLUSTRATIONS]: t('EnChapterType.ILLUSTRATIONS'),
      [EnChapterType.PROLOGUE]: t('EnChapterType.PROLOGUE'),
      [EnChapterType.ADDITIONAL]: t('EnChapterType.ADDITIONAL'),
    }
  }
}
